import React, { useState, useEffect, useRef } from 'react';
import Button from "app/components/CustomButtons/Button.js";
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Card from "app/components/Card/Card.js";
import CardHeader from "app/components/Card/CardHeader.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import { makeStyles } from "@material-ui/core/styles";
import PackageTable from "app/components/ShipmentPackages/PackageTableDQuote.js";
import axios from 'axios';
import $ from 'jquery';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { darkBlueColor } from 'app/layout/material-dashboard-react';
import CircularProgress from '@mui/material/CircularProgress';

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
    },
};

const useStyles = makeStyles(styles);


//React export function used to create the add packages function
export default function PackagesForm(props) {
    const classes = useStyles();

    const [textShipmentButton, setTextShipmentButton] = useState('Save');
    const [packages, setPackages] = useState([]);
    const [pendingQuotePackage, setPendingQuotePackage] = useState(false);
    const myRef = useRef(null);

    useEffect(() => {
        setPackages(props.BookingPackages || []);
        myRef.current.scrollIntoView();
    }, [props.BookingPackages]);

    //Handle the on submit request to post the shipment 
    const onSubmit = (e) => {
        setPendingQuotePackage(true);
        e.preventDefault();

        const form = e.currentTarget;

        const formData = new FormData(form);

        const plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/shipment/PostShipmentPackages`,
                formDataJsonString
            )
            .then(function (response) {
                if (response.data !== null) {
                    $("#sucess").show();
                    $("#error").hide();

                    setTimeout(() => {
                        $("#sucess").hide();
                    }, 5000)

                    //call getshipmentpackage to get the new packages with their ids and assign to the rows.

                    if (response.status === 200) {
                        setTextShipmentButton('Save Edit')
                    }
                    axios
                        .get(`${process.env.REACT_APP_API_ENDPOINT}/api/shipment/GetShipmentPackagesByID`, { params: { shipmentID: response.data } })
                        .then((res) => {
                            setPackages(res.data);
                        })
                        .catch((e) => {
                            console.log('error happened');
                        });
                } else {
                    $("#sucess").hide();
                    $("#error").show();

                    setTimeout(() => {
                        $("#error").hide();
                    }, 5000)
                }
                setPendingQuotePackage(false);
            })
            .catch(function (error) {
                setPendingQuotePackage(false);
                console.log(error);
            });

    };

    //Render the packages form
    return (
        <form ref={myRef} onSubmit={onSubmit}>
            <input type="hidden" name="ShipmentID" id="ShipmentID" value={props.ShipmentID} className="form-control" />
            <GridContainer>
                <GridItem>
                    <Card>
                        <CardHeader style={{ backgroundColor: darkBlueColor }}>
                            <h4 className={classes.cardTitleWhite}>{props.Type} Packages</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12}>
                                    <PackageTable BookingPackages={packages} CargoMode={props.CargoMode} PrimaryTransportMode={props.PrimaryTransportMode}/>
                                </GridItem>
                            </GridContainer>
                            <GridContainer align="center">
                                <GridItem xs={12} md={4}>
                                    <div id="sucess" style={{ display: "none" }}>
                                        <Alert severity="success">
                                            <AlertTitle>{props.Type} Saved</AlertTitle>
                                        </Alert>
                                    </div>
                                    <div id="error" style={{ display: "none" }}>
                                        <Alert severity="error">
                                            <AlertTitle>Error saving {props.Type}</AlertTitle>
                                        </Alert>
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            <Button color="purple" disabled={pendingQuotePackage} type="submit">{textShipmentButton}</Button>
                            {pendingQuotePackage && (<CircularProgress style={{ position: 'absolute', marginLeft: 30, color: '#FFF' }}></CircularProgress>)}
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </form>
    );
}